import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { CartoLayer, colorBins} from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';

export const TSN_HISTORICAL_INTERSECTION_LAYER_ID = 'tsnHistoricalIntersectionLayer';

export const CATEGORY_COLORS = {
  Parcel: [0, 100, 214],
};

const layerConfig = {
  title: 'VRU Intersection Crashes',
};

function TsnHistoricalIntersectionLayer() {
  const dispatch = useDispatch();
  const { tsnHistoricalIntersectionLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>  selectSourceById(state, tsnHistoricalIntersectionLayer?.source));

  const cartoLayerProps = useCartoLayerProps({ source });

  const viewState = useSelector((state) => state.carto.viewState);
  const pointRadiusMinPixels = viewState.zoom >= 7 ? 4 : 2;
   let [domainArray, setDomainArray] = useState([1, 25, 75, 150, 200]);
  
   
  if (tsnHistoricalIntersectionLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: TSN_HISTORICAL_INTERSECTION_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: tsnHistoricalIntersectionLayer.visible,
      opacity: tsnHistoricalIntersectionLayer.opacity,
      getFillColor: colorBins({
        attr: 'Crash_Volume',
        domain: domainArray,
        colors: [
          [235, 74, 64, 0],
          [235, 74, 64, 64],
          [235, 74, 64, 128],
          [235, 74, 64, 192],
          [235, 74, 64, 255],
        ],
      }),
      pointRadiusMinPixels: pointRadiusMinPixels,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: TSN_HISTORICAL_INTERSECTION_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default TsnHistoricalIntersectionLayer;
